var map = {
	"./social-500px.svg": 272,
	"./social-dribbble.svg": 273,
	"./social-facebook.svg": 274,
	"./social-github.svg": 275,
	"./social-google.svg": 276,
	"./social-instagram.svg": 277,
	"./social-odnoklassniki.svg": 278,
	"./social-rediit.svg": 279,
	"./social-stackoverflow.svg": 280,
	"./social-steam.svg": 281,
	"./social-twitch.svg": 282,
	"./social-twitter.svg": 283,
	"./social-vkontakte.svg": 284,
	"./social-windows.svg": 285,
	"./social-yahoo.svg": 286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 271
// module chunks = 0